import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, useTheme, useMediaQuery} from "@material-ui/core";
import { observer } from "mobx-react";
import { useStores } from "../../../../../hooks";
import ModifiersSetsAutocomplete from "../../../../../common/components/autocomplete/ModifiersSetsAutocomplete";
import { SnackbarType } from "../../../../../stores/common";
import {Trans, useTranslation} from "react-i18next";


interface Props {
    closeForm: () => void;
    addToSet: (modifierSetId: number) => void;
    isOpen: boolean
}

const AddModifiersSetToMenuItemForm = (props: Props) => {
    const [modifierSetId, setModifierSetId] = useState<number | null>(null);
    const {i18n, t} = useTranslation(["general", "menu"]);

    const {generalStore} = useStores();
    useEffect(() => {
        setModifierSetId(null);
    }, [props.isOpen]);

    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));



    let title = t("menu:menuEditor.addingSet");

    return (
        <Dialog
            open={props.isOpen}
            onClose={props.closeForm}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <form autoComplete="off">
                    <FormControl fullWidth margin={"normal"}>
                        <ModifiersSetsAutocomplete
                            setModifierSetId={setModifierSetId}
                            modifierSetId={modifierSetId}
                            additionalValues={[]}
                        />
                    </FormControl>
                </form>
            </DialogContent>

            <DialogActions>
                <Button onClick={props.closeForm} color="primary">
                    {t("general:cancel")}
                </Button>
                <Button
                    color="primary"
                    variant='contained'
                    onClick={() => {
                        if(!modifierSetId){
                            generalStore.showSnackbar({
                                title: t("menu:menuEditor.selectModifierSet"),
                                description: t("menu:menuEditor.noSelectedModifierSets"),
                                type: SnackbarType.warning
                            });
                        }else{
                            props.addToSet(modifierSetId)
                        }
                    }}
                >
                    {t("general:add")}
                </Button>
            </DialogActions>
        </Dialog>
    );

};

export default observer(AddModifiersSetToMenuItemForm);
